import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { COLORS, TYPO, SPACE, RADIUS, hladaj } from '../theme.js'
import { PageHeader, MasterDetail, SearchInput, ListRow, ListStatusBar, EmptyPane, KpiRow, KpiCard, SearchableSelect, FilterChips } from '../components/Ui.jsx'
import RowMenu from '../components/RowMenu.jsx'
import { KontaktnaOsoba } from '../components/KontaktyPartnera.jsx'   // ústava 131.10 + 0.J — jeden blok kontaktnej osoby (p93)
import { Modal } from '../components/Modal.jsx'
import { useToast } from '../components/Toast.jsx'
import { BtnAdd, BtnNav } from '../components/Btn.jsx'
import NavIcon from '../components/NavIcon.jsx'
import { HistoryPanel } from '../components/HistoryPanel.jsx'
import { useRecordEditor } from '../hooks/useRecordEditor.js'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { usePinGate } from '../hooks/usePinGate.jsx'   // p105: rozpad ceny sa otvara PIN-om (ustava 63)
import { useShortcuts } from '../hooks/useShortcuts.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { isMatica, freshMatica, sumKalkAny, stavbaNazov } from '../lib/kalkMatica.js'
import KalkulacieMatica from './KalkulacieMatica.jsx'
import KalkulackaJC from './KalkulackaJC.jsx'
import VVTab from './VVTab.jsx'

// Kalkulácie cien (Riadenie) — súkromné, majiteľ/office. Master-detail (ústava sek. 56).
// Generické materiály (NIE z VV), 3 typy: omietky / maľby / potery. Materiál PLU +5 %, práca/réžia ručne.
// VV import (AI) voliteľný. Väzba na dopyt.

const BRAND = '#D85A30'
const PREP_BG = '#eef3f8'  // tónované pozadie prepočtu (odlíšenie, Mirko 2026-06-27)
const tok = () => localStorage.getItem('kamir_token') || ''
const api = (u, o = {}) => fetch(u, { ...o, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tok(), ...(o.headers || {}) } })
const e2 = (n) => (Number(n) || 0).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const e0 = (n) => (Number(n) || 0).toLocaleString('sk-SK', { maximumFractionDigits: 0 })
const uid = () => 'p' + Math.random().toString(36).slice(2, 9)
const MAT_BUFFER = 1.05

const TYPY = {
  omietka: {
    l: 'Omietka', pred: 13.90, matLabel: null,
    special: [], mat: null,
    lines: [['material', 'Materiál (sadra/cement)', 2.52, null, true], ['robota', 'Robota', 6.00, 'ručne'], ['rohovnik', 'Rohovník', 0.09, null, true], ['apu', 'APU lišta', 0.10, null, true], ['rotor', 'Rotor-stator', 0.10, null, true], ['pasky', 'Pásky', 0.05, null, true], ['folie', 'Fólie', 0.05, null, true], ['penetr', 'Penetrácia / BetónKontakt', 0.20, null, true], ['sietka', 'Sieťka', 0.05, null, true], ['prevoz', 'Prevoz', 0.20], ['majster', 'Majster', 0.25], ['servis', 'Servis', 0.05], ['smetie', 'Smetie', 0.10], ['nepr', 'Nepredvídané', 0.10], ['rezia', 'Réžia firmy', 1.00, 'odhad']],
  },
  malba: {
    l: 'Maľba', pred: 3.49, matLabel: null, special: [], mat: null,
    lines: [['farba', 'Materiál (farba)', 1.00, null, true], ['robota', 'Robota', 1.20, 'ručne'], ['matsp', 'Materiál spotrebný', 0.28, null, true], ['penetr', 'Penetrácia', 0.10, null, true], ['akryl', 'Akryl', 0.00, null, true], ['vyspr', 'Výspravky', 0.00], ['nepr', 'Nepredvídané', 0.00], ['rezia', 'Réžia firmy', 0.30, 'odhad']],
  },
  poter: {
    l: 'Poter', pred: 19.90, matLabel: 'Anhydrit + ľudia/doprava',
    special: [{ k: 'hr', l: 'Hrúbka', v: 0.06, u: 'm' }, { k: 'cm', l: 'Cena anhydritu', v: 224, u: '€/m³', tag: 'PLU' }, { k: 're', l: 'Počet realizácií', v: 8, u: 'dní' }, { k: 'cd', l: 'Cena/realizácia (4 ľudia+doprava)', v: 500, u: '€' }, { k: 'pl', l: 'Plocha', v: 4000, u: 'm²' }],
    mat: (s) => (Number(s.hr) || 0) * ((Number(s.cm) || 0) * MAT_BUFFER) + ((Number(s.re) || 0) * (Number(s.cd) || 0) / (Number(s.pl) || 1)),
    lines: [['robota', 'Robota', 3.50, 'ručne'], ['folia', 'Fólia', 0.11, null, true], ['geotex', 'Geotextília', 0.30, null, true], ['kari', 'Kari rohož', 0.00, null, true], ['rezia', 'Réžia firmy', 0.50, 'odhad']],
  },
}
function freshPolozka(typ, extra) {
  const t = TYPY[typ] || TYPY.omietka
  const special = {}; (t.special || []).forEach(s => { special[s.k] = s.v })
  return { id: uid(), typ, objekt: (extra && extra.objekt) || '', popis: (extra && extra.popis) || t.l, kod: (extra && extra.kod) || '', mnozstvo: (extra && extra.mnozstvo != null) ? extra.mnozstvo : '', special, lines: t.lines.map(([k, l, v, tag, mat]) => ({ k, l, tag, mat: !!mat, v, cena: v, cenaUnit: mat ? 'ks' : 'm²', pocet: 1, vymeraKs: 1, plocha: 1 })), predajna: t.pred }
}
const guessTyp = (kod) => { const c = String(kod || ''); if (/^61/.test(c)) return 'omietka'; if (/^63/.test(c)) return 'poter'; if (/^78[34]/.test(c)) return 'malba'; return 'omietka' }
// PLU-naviazaný riadok = aktuálna cena z MKsoft × spotreba na m² × +5 %. Inak ručná €/m².
// Prepočet spotreby/m² = počet × výmera/ks ÷ plocha (napr. 50 ks × 2,75 bm / 400 m²). Spätná kompat: starý field spotreba.
const lineSpotreba = (l) => (Number(l.pocet) || 0) * (Number(l.vymeraKs) || 1) / (Number(l.plocha) || 1)
const lineUnitPrice = (l) => l.plu ? (Number(l.pluPrice) || 0) : (Number(l.cena) || 0)
const lineVal = (l) => {
  if (l.cena == null && l.pocet == null) return Number(l.v) || 0  // spätná kompat (staré dáta)
  return lineUnitPrice(l) * lineSpotreba(l) * (l.mat ? MAT_BUFFER : 1)  // +5 % len materiál
}
function computeP(p) {
  const t = TYPY[p.typ] || TYPY.omietka
  const matPerM2 = t.mat ? t.mat(p.special || {}) : 0
  const linesSum = (p.lines || []).reduce((a, l) => a + lineVal(l), 0)
  const naklad = matPerM2 + linesSum
  const predajna = Number(p.predajna) || 0
  const zisk = predajna - naklad
  const rabat = naklad > 0 ? (predajna / naklad) * 100 : 0
  const mn = Number(p.mnozstvo) || 0
  return { matPerM2, naklad, predajna, zisk, rabat, mn, nakladSpolu: naklad * mn, trzbaSpolu: predajna * mn, ziskSpolu: zisk * mn }
}
const sumKalk = (r) => (((r.data || {}).polozky) || []).reduce((a, p) => { const c = computeP(p); return { n: a.n + c.nakladSpolu, t: a.t + c.trzbaSpolu, z: a.z + c.ziskSpolu } }, { n: 0, t: 0, z: 0 })

const NEW = '__new__'
// p90: stavy kalkulácie — filtre a štítky (ústava 66.1 bod 2, 66.2)
const STAVY_KALK = [
  { key: 'all', label: 'Všetko', color: COLORS.muted },
  { key: 'pracovna', label: 'Pracovné', color: COLORS.muted },
  { key: 'podana', label: 'Podané', color: COLORS.nav },
  { key: 'vyhrana', label: 'Vyhrané', color: COLORS.add },
  { key: 'nevyhrana', label: 'Nevyhrané', color: '#b91c1c' },
]
const stavKalk = (s) => STAVY_KALK.find(x => x.key === (s || 'pracovna')) || STAVY_KALK[1]
// Tržba/zisk z uloženého výpočtu (p84) — nie zo starého modelu položiek
const vypocetSpolu = (r) => { const v = r && r.data && r.data.vypocet && r.data.vypocet.spolu; return v ? { t: Number(v.trzba_spolu) || 0, z: Number(v.zisk_spolu) || 0 } : { t: 0, z: 0 } }

export default function KalkulacieView() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [denied, setDenied] = useState(false)
  const [search, setSearch] = useState('')
  const [filtStav, setFiltStav] = useState('all')
  const [selectedId, setSelectedId] = useState(null)
  const [draft, setDraft] = useState(null)
  // Rýchly výpočet ceny (Mirko 2026-09-20) — len ukáže cenu, NIČ nezakladá. Kalkuláciu robí „+ Nová kalkulácia".
  const [rychly, setRychly] = useState(false)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const r = await api('/api/kalkulacie')
      if (r.status === 403) { setDenied(true); setRows([]); return }
      setRows(await r.json())
    } catch (e) { console.error(e) } finally { setLoading(false) }
  }, [])
  useEffect(() => { load() }, [load])

  const filtered = useMemo(() => {
    // ústava 12.0 bod 4a: hľadanie bez ohľadu na diakritiku; hľadá aj v čísle, zákazníkovi, stavbe a kontakte
    const bez = (x) => String(x || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    const q = bez(search.trim())
    const podlaStavu = filtStav === 'all' ? rows : rows.filter(r => (r.stav || 'pracovna') === filtStav)
    if (!q) return podlaStavu
    return podlaStavu.filter(r => [r.nazov, r.poznamka, r.cislo, r.zakaznik_nazov, r.stavba, r.kontakt_osoba].some(x => bez(x).includes(q)))
  }, [filtStav, rows, search])

  // ── klávesová navigácia zoznamu (ústava 54.2, 56.5) — zdieľaný hook ──
  useListKeyboard({
    items: filtered,
    selectedId,
    onSelect: id => setSelectedId(id),
    onOpen: row => setSelectedId(row.id),   // výber = otvorenie detailu (master-detail, bez modalu)
    enabled: selectedId !== NEW,            // pri rozpísanom novom drafte nenavigovať (draft by sa zahodil)
  })

  // ── klávesové skratky (ústava sek. 54) — '/' fokus do vyhľadávania ──
  useShortcuts([
    { keys: '/', label: 'Hľadať', scope: 'kalkulacie', handler: () => {
      const el = document.querySelector('[data-kalkulacie-search]')
      if (el) el.focus()
    } },
  ])

  const newKalk = () => { setDraft({ nazov: '', dopyt_id: '', poznamka: '', data: { v: 2, matica: freshMatica() } }); setSelectedId(NEW) }
  const selected = selectedId === NEW ? draft : (rows.find(r => String(r.id) === String(selectedId)) || null)

  // p103 (Mirko 22. 9. 2026: „prejsť rýchlo z kontaktu do zamestnanca alebo partnera"): ?open=<id> otvorí kartu
  const [openZKontaktov, setOpenZKontaktov] = useState(() => { try { return new URLSearchParams(window.location.search).get('open') } catch (_) { return null } })
  useEffect(() => {
    if (!openZKontaktov || !rows || !rows.length) return
    const r = rows.find(x => String(x.id) === String(openZKontaktov)); setOpenZKontaktov(null)
    if (r) { setSelectedId(r.id) }
  }, [rows])  // eslint-disable-line react-hooks/exhaustive-deps

  const kpi = useMemo(() => rows.reduce((a, r) => { const s = sumKalkAny(r, sumKalk); return { t: a.t + s.t, z: a.z + s.z } }, { t: 0, z: 0 }), [rows])

  if (denied) return (
    <div style={{ padding: 40, textAlign: 'center', color: COLORS.muted }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8, color: COLORS.muted }}><NavIcon name="lock" size={34} /></div>
      <div style={{ fontWeight: 700, color: COLORS.text }}>Kalkulácie sú súkromné</div>
      <div style={{ fontSize: 13, marginTop: 4 }}>Dostupné len pre Majiteľa / vedúceho office.</div>
    </div>
  )

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <PageHeader title="Kalkulácie" subtitle={`${filtered.length} z ${rows.length} · Riadenie`}>
        {/* Rovnaká veľkosť (obe cez Btn) a pri oboch hint, čo robia — Mirko 2026-09-20. */}
        <BtnNav onClick={() => setRychly(true)}
          title="Len spočíta cenu na m². Nič sa neuloží, nič nepribudne v zozname vľavo. Na overenie, či sa nám cena oplatí.">Rýchly výpočet ceny</BtnNav>
        <span style={{ display: 'inline-block', width: 8 }} />
        <BtnAdd onClick={newKalk}
          title="Založí kalkuláciu pre konkrétnu zákazku alebo súťaž — so zákazníkom, číslom a stavom. Uloží sa a ostane v zozname vľavo.">+ Nová kalkulácia</BtnAdd>
      </PageHeader>
      {rychly && <KalkulackaJC rychly onClose={() => setRychly(false)} />}

      <KpiRow cols={3}>
        <KpiCard title="Kalkulácie" color={COLORS.nav} value={rows.length} />
        <KpiCard title="Tržba spolu" color={COLORS.brand} value={e0(rows.reduce((a, r) => a + vypocetSpolu(r).t, 0)) + ' €'} />
        <KpiCard title="Zisk spolu" color={COLORS.add} value={e0(rows.reduce((a, r) => a + vypocetSpolu(r).z, 0)) + ' €'} />
      </KpiRow>

      <div style={{ height: SPACE.md }} />

      <MasterDetail
        left={
          <>
            <div style={{ padding: '6px 6px 0' }}><FilterChips options={STAVY_KALK} value={filtStav} onChange={setFiltStav} /></div>
            <SearchInput value={search} onChange={setSearch} placeholder="Hľadať kalkuláciu…" dataAttr="data-kalkulacie-search" />
            <div style={{ flex: 1, overflow: 'auto', padding: 6 }}>
              {loading ? <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Načítavam…</div>
                : !filtered.length ? <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Žiadne kalkulácie — vytvor novú.</div>
                  : filtered.map(r => {
                    // ústava 66.2: zákazník tučne + štítok stavu vpravo; pod tým stavba · číslo · dátum (mono); pásik farbou stavu
                    const st = stavKalk(r.stav)
                    const dt = String(r.datum || r.created_at || '').slice(0, 10).split('-').reverse().join('.')
                    const vs = vypocetSpolu(r)
                    return (
                      <ListRow key={r.id} dataId={r.id} selected={String(r.id) === String(selectedId)} stripColor={st.color}
                        onClick={() => { setDraft(null); setSelectedId(r.id) }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6, alignItems: 'center' }}>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontWeight: TYPO.weights.semibold, color: COLORS.text, wordBreak: 'break-word' }}>{r.zakaznik_nazov || r.nazov || '(bez zákazníka)'}</div>
                            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono, marginTop: 2 }}>
                              {(r.stavba || r.nazov || '(stavba nevyplnená)')} · {r.cislo || ('#' + r.id)}{dt ? ' · ' + dt : ''}
                            </div>
                            {((r.reg_meno || r.kontakt_osoba) || vs.t > 0) && (
                              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 1 }}>
                                {r.reg_meno || r.kontakt_osoba || ''}{(r.reg_meno || r.kontakt_osoba) && vs.t > 0 ? ' · ' : ''}{vs.t > 0 ? <span style={{ color: COLORS.text, fontWeight: 600 }}>{e0(vs.t)} €</span> : null}
                              </div>
                            )}
                          </div>
                          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span style={{ fontSize: 10.5, fontWeight: 700, padding: '2px 7px', borderRadius: 999, color: st.color, border: '1px solid ' + st.color, background: '#fff', whiteSpace: 'nowrap' }}>{st.label.replace(/é$/, 'á')}</span>
                            <RowMenu actions={[
                              { key: 'open', label: 'Otvoriť', onClick: () => { setDraft(null); setSelectedId(r.id) } },
                              { key: 'copy', label: 'Kópia', onClick: async () => {
                                if (!window.confirm('Vytvoriť kópiu kalkulácie „' + (r.nazov || '') + '"? Dostane nové číslo a stav Pracovná.')) return
                                const resp = await api('/api/kalkulacie', { method: 'POST', body: JSON.stringify({ ...r, id: undefined, cislo: '', stav: 'pracovna', nazov: (r.nazov || '') + ' (kópia)', data: r.data || {} }) })
                                if (resp.ok) { const j = await resp.json(); await load(); setSelectedId(j.id) }
                              } },
                              { key: 'del', label: 'Archivovať', danger: true, onClick: async () => {
                                if (!window.confirm('Archivovať kalkuláciu „' + (r.nazov || '') + '"? Nezmaže sa, dá sa vrátiť.')) return
                                const resp = await api('/api/kalkulacie/' + r.id, { method: 'DELETE' })
                                if (resp.ok) { if (String(selectedId) === String(r.id)) setSelectedId(null); await load() }
                              } },
                            ]} />
                          </div>
                        </div>
                      </ListRow>
                    )
                  })}
            </div>
            <ListStatusBar>{filtered.length} kalkulácií · klik = detail</ListStatusBar>
          </>
        }
        right={
          selected
            ? <KalkDetailPane key={selectedId} record={selected} isNew={selectedId === NEW}
                onCancel={() => { setSelectedId(null); setDraft(null) }}
                onSaved={(saved) => { setDraft(null); load(); setSelectedId(saved && saved.id != null ? saved.id : null) }}
                onArchived={() => { setSelectedId(null); load() }} />
            : <EmptyPane text="Vyber kalkuláciu vľavo, alebo vytvor novú (+ Nová kalkulácia)" icon={<NavIcon name="kalkulacie" size={44} />} />
        }
      />
    </div>
  )
}


// ── Prílohy dopytu + načítanie výkazu výmer (p77, Mirko 2026-09-20: „a kde je VV?") ──────────────
// Výkaz už leží na dopyte ako príloha (p73). Netreba ho nahrávať znova — stačí ho načítať.
function PrilohyDopytu({ dopytId, kalkulaciaId, onNacitane }) {
  const [rows, setRows] = useState(null)
  const [busy, setBusy] = useState('')
  const [chyba, setChyba] = useState('')
  useEffect(() => {
    api('/api/attachments?entity_type=dopyt&entity_id=' + encodeURIComponent(dopytId))
      .then(r => r.ok ? r.json() : []).then(d => setRows(Array.isArray(d) ? d : [])).catch(() => setRows([]))
  }, [dopytId])
  if (!rows) return null
  const jeVykaz = (f) => /\.(xlsx|xlsm|xlsb|xls|csv|ods)$/i.test(String(f || ''))
  const vyplnit = async (at) => {
    setBusy('v' + at.id); setChyba('')
    try {
      const r = await api('/api/attachments/' + at.id + '/vykaz/vyplnit', { method: 'POST', body: JSON.stringify({ kalkulacia_id: String(kalkulaciaId || '') }) })
      if (!r.ok) { const j = await r.json().catch(() => ({})); setChyba(j.error || 'Vyplnenie zlyhalo'); return }
      const a = document.createElement('a'); a.href = URL.createObjectURL(await r.blob())
      a.download = at.fname.replace(/\.[^.]+$/, '') + ' - nacenene KAMIR.xlsx'
      document.body.appendChild(a); a.click(); a.remove()
    } catch (e) { setChyba('Chyba: ' + e.message) } finally { setBusy('') }
  }

  const nacitaj = async (at) => {
    setBusy(at.id); setChyba('')
    try {
      const r = await api('/api/budget-items/ai-parse', { method: 'POST', body: JSON.stringify({ attachment_id: at.id }) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) { setChyba(j.error || 'Načítanie zlyhalo'); return }
      const items = j.items || []
      if (!items.length) { setChyba('AI z tohto súboru nevytiahla ani jednu položku.'); return }
      // Položky idú do Výkazu výmer kalkulácie — tam, kde ich Mirko chce vidieť (ústava 0.J).
      // Objekt ostáva ako prefix [X] v popise, presne ako to robí VVTab v zákazkách.
      // Profesia podľa SÚBORU — tak, ako to rozdelil zákazník (Mirko 2026-09-21: „ak bol pôvodný
      // výkaz osobitne, aj tento musí byť osobitne"). Súbor „…omietky.xlsx" = omietky atď.
      const n = String(at.fname || '').toLowerCase()
      const remeslo = /omiet/.test(n) ? 'omietka' : /mal[bi]|maľb|náter|nater/.test(n) ? 'malba' : /poter|anhydrit/.test(n) ? 'poter' : ''
      let ulozene = 0
      for (const it of items) {
        const popis = (it.objekt ? '[' + String(it.objekt).trim() + '] ' : '') + String(it.popis || '').trim()
        if (!popis) continue
        const mn = Number(it.mnozstvo) || 0, jc = Number(it.cena) || 0
        const r = await api('/api/budget-items', { method: 'POST', body: JSON.stringify({
          projectId: '', kalkulacia_id: String(kalkulaciaId || ''), remeslo, position: ulozene, description: popis,
          unit: it.mj || 'm²', quantity: mn, unit_price: jc, total_price: Math.round(mn * jc * 100) / 100,
          notes: it.kod ? 'CENKROS: ' + it.kod : '',
        }) })
        if (r.ok) ulozene++
      }
      if (!ulozene) { setChyba('Položky sa nepodarilo uložiť do výkazu.'); return }
      onNacitane(ulozene)
    } catch (e) { setChyba('Chyba: ' + e.message) } finally { setBusy('') }
  }
  return (
    <div style={{ ...card, marginBottom: 10 }}>
      <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '.07em', color: '#94a3b8', fontWeight: 700, marginBottom: 8 }}>
        Prílohy dopytu #{dopytId} {rows.length ? '(' + rows.length + ')' : ''}
      </div>
      {!rows.length && <div style={{ fontSize: 12.5, color: '#94a3b8' }}>Dopyt nemá žiadne prílohy. Výkaz výmer nahraj do dopytu, alebo pridaj položky ručne nižšie.</div>}
      {rows.map(at => (
        <div key={at.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderTop: '1px solid #f5f1ee', fontSize: 13 }}>
          <a href={at.url} target="_blank" rel="noreferrer" style={{ color: '#1e293b', textDecoration: 'none', flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={'Otvoriť ' + at.fname}>{at.fname}</a>
          <span style={{ fontSize: 11.5, color: '#94a3b8', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{Math.round((at.size || 0) / 1024)} kB</span>
          {jeVykaz(at.fname) ? <>
            <button onClick={() => nacitaj(at)} disabled={!!busy} title="Prečíta výkaz a jeho položky sa objavia vo Výkaze výmer nižšie. Súbor na dopyte ostáva nedotknutý."
              style={{ border: '1px solid ' + BRAND, background: busy === at.id ? '#f5f1ee' : BRAND, color: busy === at.id ? '#993c1d' : '#fff', borderRadius: 7, padding: '4px 11px', fontWeight: 700, fontSize: 12, cursor: busy ? 'default' : 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' }}>
              {busy === at.id ? 'Čítam…' : 'Načítať do výkazu'}
            </button>
            <button onClick={() => vyplnit(at)} disabled={!!busy}
              title="Stiahne TENTO ich súbor s našimi cenami. Páruje sa podľa kódu CENKROS — riadky, poradie ani hárky sa nemenia, aby si to vedeli nahrať do svojho výkazu."
              style={{ border: '1px solid #15803d', background: '#fff', color: '#15803d', borderRadius: 7, padding: '4px 11px', fontWeight: 700, fontSize: 12, cursor: busy ? 'default' : 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' }}>
              {busy === 'v' + at.id ? 'Pripravujem…' : 'Vyplniť našimi cenami'}
            </button>
          </> : <span style={{ fontSize: 11.5, color: '#cbd5e1', whiteSpace: 'nowrap' }}>nie je výkaz</span>}
        </div>
      ))}
      {chyba && <div style={{ marginTop: 8, background: '#FDECEC', border: '1px solid #f0a8a8', borderRadius: 8, padding: '7px 11px', fontSize: 12.5, color: '#dc2626' }}>{chyba}</div>}
    </div>
  )
}


// ── NAŠE NÁKLADY — interné PDF (p93, Mirko 2026-09-21: „daj tlačidlo odoslať naše náklady, nech viem poslať
// kolegom v PDF — report našej nákladovej ceny aj jej výpočet"). Zákazníkovi sa NEPOSIELA — jemu ide VV a ponuka.
// PDF počíta server z uložených vstupov tou istou funkciou ako Výpočet ceny, na oficiálnom hlavičkovom papieri.
function NaseNaklady({ kalkId, cislo, nazov }) {
  const toast = useToast()
  const [open, setOpen] = useState(false)
  const [komu, setKomu] = useState('')
  const [text, setText] = useState('')
  const [adresy, setAdresy] = useState([])
  const [busy, setBusy] = useState(false)
  const subor = 'Nase_naklady_' + String(cislo || kalkId).replace(/[^a-zA-Z0-9_-]/g, '_') + '.pdf'
  const stiahni = async () => {
    try {
      const r = await api('/api/kalkulacie/' + kalkId + '/naklady-pdf')
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.error || ('HTTP ' + r.status)) }
      const u = URL.createObjectURL(await r.blob())
      const a = document.createElement('a'); a.href = u; a.download = subor
      document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(u), 5000)
    } catch (e) { toast.error('Naše náklady: ' + e.message) }
  }
  const otvor = async () => {
    setText('Ahoj,\n\nv prílohe posielam naše náklady ku kalkulácii ' + (cislo || ('#' + kalkId)) + (nazov ? ' — ' + nazov : '')
      + ': nákladovú cenu na m² a jej výpočet po položkách.\n\nInterné — zákazníkovi neposielať.')
    setOpen(true)
    try { const r = await api('/api/kalkulacie/naklady/adresy'); if (r.ok) { const j = await r.json(); setAdresy(Array.isArray(j.adresy) ? j.adresy : []) } } catch (_) {}
  }
  const pridajAdresu = (a) => setKomu(s => { const z = s.split(/[,;\s]+/).filter(Boolean); return z.includes(a) ? s : [...z, a].join(', ') })
  const odosli = async () => {
    if (busy) return
    if (!komu.trim()) { toast.error('Zadaj aspoň jednu adresu kolegu.'); return }
    setBusy(true)
    try {
      const r = await api('/api/kalkulacie/' + kalkId + '/naklady/odoslat', { method: 'POST', body: JSON.stringify({ komu, text }) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(j.error || ('HTTP ' + r.status))
      toast.success('Naše náklady odoslané: ' + (j.komu || []).join(', '))
      setOpen(false); setKomu('')
    } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  const pole = { width: '100%', padding: '8px 10px', border: '1px solid #d6dde6', borderRadius: 8, fontFamily: 'inherit', fontSize: 13, boxSizing: 'border-box' }
  return (
    <>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap', marginBottom: 8 }}>
        <BtnNav onClick={stiahni} title="Stiahne PDF s našou nákladovou cenou a jej výpočtom po položkách. Interné — zákazníkovi sa neposiela.">Naše náklady (PDF)</BtnNav>
        <BtnNav onClick={otvor} title="Pošle PDF s našou nákladovou cenou a jej výpočtom kolegom e-mailom. Interné — zákazníkovi sa neposiela.">Odoslať naše náklady</BtnNav>
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title="Odoslať naše náklady" maxWidth={560} width="min(560px, 95vw)"
        subtitle="Interný dokument: naša nákladová cena a jej výpočet. Zákazníkovi sa neposiela."
        footer={<>
          <BtnNav onClick={() => setOpen(false)}>Zrušiť</BtnNav>
          <BtnAdd onClick={odosli} disabled={busy}>{busy ? 'Odosielam…' : 'Odoslať PDF'}</BtnAdd>
        </>}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <label style={lab}>Komu — kolegovia (viac adries oddeľ čiarkou)
            <input value={komu} onChange={e => setKomu(e.target.value)} placeholder="meno@firma.sk" style={{ ...pole, marginTop: 4 }} autoFocus />
          </label>
          {adresy.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center' }}>
              <span style={{ fontSize: 11.5, color: '#64748b' }}>Firemné schránky:</span>
              {adresy.map(a => (
                <button key={a} type="button" onClick={() => pridajAdresu(a)}
                  style={{ padding: '2px 9px', fontSize: 11.5, borderRadius: 12, border: '1px solid #d6dde6', background: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>{a}</button>
              ))}
            </div>
          )}
          <label style={lab}>Správa
            <textarea value={text} onChange={e => setText(e.target.value)} rows={6} style={{ ...pole, marginTop: 4, resize: 'vertical' }} />
          </label>
          <div style={{ fontSize: 12, color: '#64748b' }}>Príloha: {subor} — počíta sa z uložených vstupov Výpočtu ceny.</div>
        </div>
      </Modal>
    </>
  )
}

// ── Detail/editor (pravý panel) — useRecordEditor: lock/dirty/DIFF/confirm + audit (ústava 53.7/53.8/12.0) ──
function KalkDetailPane({ record, isNew, onCancel, onSaved, onArchived }) {
  const { user } = useAuth()
  const [dopyty, setDopyty] = useState([])
  const [zakaznici, setZakaznici] = useState([])
  const [vvOpen, setVvOpen] = useState(false)
  const [histOpen, setHistOpen] = useState(false)
  const [vvTick, setVvTick] = useState(0)   // po načítaní výkazu z prílohy sa VV obnoví
  const [ulozeneO, setUlozeneO] = useState(record && record.data && record.data.vypocet_ulozeny ? String(record.data.vypocet_ulozeny).slice(11, 16) : '')

  // Výpočet sa ukladá SÁM (Mirko 2026-09-21: „musí sa ukladať, automaticky alebo tlačidlom").
  // Posiela sa CELÉ data, lebo PUT ich prepisuje celé. Nová, ešte neuložená kalkulácia si ho drží
  // v editore a uloží sa s prvým Uložiť. Podanú kalkuláciu server nepustí (409) — tak to má byť.
  // p91: vstupy sa ukladajú samy aj bez prepočtu (sumy na stavbu, prepisy cien pre stavbu, všetky polia).
  // p100: omietky ostávajú v data.vstup (ako doteraz), maľby a potery idú do data.remesla.<remeslo>.
  const ulozVstup = async (vstup, remeslo = 'omietka') => {
    const kedy = new Date().toISOString()
    const d = ed.values.data || {}
    const nova = remeslo === 'omietka'
      ? { ...d, vstup, vstup_ulozeny: kedy }
      : { ...d, remesla: { ...(d.remesla || {}), [remeslo]: { ...((d.remesla || {})[remeslo] || {}), vstup, vstup_ulozeny: kedy } } }
    ed.set('data', nova)
    if (isNew || !record || !record.id) return
    try {
      const r = await api('/api/kalkulacie/' + record.id, { method: 'PUT', headers: pinHlavicka(), body: JSON.stringify({ data: nova }) })
      if (r.ok) setUlozeneO(kedy.slice(11, 16))
    } catch (_) {}
  }

  const ulozVypocet = async (vy, remeslo = 'omietka') => {
    const kedy = new Date().toISOString()
    const d = ed.values.data || {}
    const nova = remeslo === 'omietka'
      ? { ...d, vstup: vy.vstup, odpis: vy.odpis, vypocet: vy.vysledok, vypocet_ulozeny: kedy }
      : { ...d, remesla: { ...(d.remesla || {}), [remeslo]: { vstup: vy.vstup, odpis: vy.odpis, vypocet: vy.vysledok, vypocet_ulozeny: kedy } } }
    ed.set('data', nova)
    if (isNew || !record || !record.id) return
    try {
      const r = await api('/api/kalkulacie/' + record.id, { method: 'PUT', headers: pinHlavicka(), body: JSON.stringify({ data: nova }) })
      if (r.ok) setUlozeneO(kedy.slice(11, 16))
    } catch (_) {}
  }
  const savedRef = useRef(null)

  useEffect(() => { api('/api/dopyty').then(r => r.json()).then(d => setDopyty(Array.isArray(d) ? d : [])).catch(() => {}) }, [])
  useEffect(() => { api('/api/customers').then(r => r.ok ? r.json() : []).then(d => setZakaznici(Array.isArray(d) ? d : [])).catch(() => {}) }, [])

  // p72 (Mirko 2026-09-20): „otvorí menu z cenovej ponuky a dole bude výpočet" — rovnaká hlavička ako CP.
  const HLAVICKA_POLIA = ['customer_id', 'stavba', 'cislo', 'datum', 'platnost_dni', 'stav', 'pripravil',
    'email', 'email2', 'telefon', 'obhliadku_vykonal', 'kontakt_osoba', 'kontakt_funkcia']
  const STAVY = [['pracovna', 'Pracovná'], ['podana', 'Podaná'], ['vyhrana', 'Vyhraná'], ['nevyhrana', 'Nevyhraná']]

  // Polia pre DIFF (ústava 53.8) — porovná initial vs. zmenené pred uložením.
  const editFields = useMemo(() => ([
    { name: 'nazov', label: 'Názov' },
    { name: 'customer_id', label: 'Zákazník', format: v => (zakaznici.find(c => String(c.id) === String(v)) || {}).name || '— nevybraný —' },
    { name: 'stavba', label: 'Stavba / projekt' },
    { name: 'cislo', label: 'Číslo kalkulácie' },
    { name: 'datum', label: 'Dátum' },
    { name: 'platnost_dni', label: 'Platnosť (dní)' },
    { name: 'stav', label: 'Stav', format: v => (STAVY.find(s => s[0] === v) || [])[1] || v },
    { name: 'pripravil', label: 'Pripravil' },
    { name: 'email', label: 'E-mail zákazníka' },
    { name: 'email2', label: 'E-mail zákazníka 2' },
    { name: 'telefon', label: 'Telefón zákazníka' },
    { name: 'kontakt_osoba', label: 'Kontaktná osoba' },
    { name: 'kontakt_funkcia', label: 'Funkcia' },
    { name: 'obhliadku_vykonal', label: 'Obhliadku vykonal' },
    { name: 'dopyt_id', label: 'Dopyt', format: v => (dopyty.find(d => String(d.id) === String(v)) || {}).nazov || '— bez dopytu —' },
    { name: 'poznamka', label: 'Poznámka' },
    { name: 'data', label: 'Rozpad ceny', format: v => {
      if (isMatica(v)) { const cs = (v.matica.cols) || []; const rs = (v.matica.rows) || []
        return cs.length + ' produkt(ov) · ' + rs.length + ' nákladov · ' + cs.map(c => (c.l || '?') + ' ' + e2(rs.reduce((a, r) => a + (Number(String((c.v || {})[r.id] ?? '').replace(',', '.')) || 0), 0)) + ' €/m²').join(' · ') }
      const ps = (v && v.polozky) || []; const nk = ps.reduce((a, p) => a + (computeP(p).naklad || 0), 0); return ps.length + ' pol. · náklad ' + e2(nk) + ' €/m²' } },
  ]), [dopyty, zakaznici])

  // p105 (Mirko 22. 9. 2026): „rozpad ceny — normálne je zatvorený, ktokoľvek ho chce zmeniť, žiada PIN."
  // Otvára sa schválením PIN-om (ústava 63, spoločný usePinGate), platí 10 minút; panel je kľúčovaný podľa
  // kalkulácie, takže pri prechode na inú kalkuláciu sa rozpad sám zatvorí. Rýchly výpočet (data.vstup/vypocet/
  // remesla) sa nezamyká — server stráži len zmenu data.matica.
  const pinGate = usePinGate()
  const [rozpad, setRozpad] = useState(null)          // { auditId, do }
  const rozpadRef = useRef(null)
  useEffect(() => { rozpadRef.current = rozpad }, [rozpad])
  useEffect(() => {
    if (!rozpad) return
    const ms = rozpad.do - Date.now()
    if (ms <= 0) { setRozpad(null); return }
    const t = setTimeout(() => setRozpad(null), ms)
    return () => clearTimeout(t)
  }, [rozpad])
  const pinHlavicka = () => { const r = rozpadRef.current; return r && r.auditId ? { 'X-Pin-Audit-Id': String(r.auditId) } : {} }
  const otvorRozpad = async () => {
    const r = await pinGate('kalkulacia_rozpad', { 'Kalkulácia': (record && (record.cislo || record.id)) || 'nová', 'Názov': (record && record.nazov) || '' })
    if (r && r.ok) setRozpad({ auditId: r.audit_id, do: Date.now() + 10 * 60 * 1000 })
  }

  const ed = useRecordEditor({
    resource: 'kalkulacie',
    id: isNew ? null : record.id,
    user,
    initial: {
      nazov: record.nazov || '',
      dopyt_id: record.dopyt_id || '',
      poznamka: record.poznamka || '',
      customer_id: record.customer_id || '',
      stavba: record.stavba || '',
      cislo: record.cislo || '',
      datum: record.datum || new Date().toISOString().slice(0, 10),
      platnost_dni: record.platnost_dni != null ? record.platnost_dni : 14,
      stav: record.stav || 'pracovna',
      pripravil: record.pripravil || (user && user.username) || '',
      email: record.email || '',
      email2: record.email2 || '',
      telefon: record.telefon || '',
      obhliadku_vykonal: record.obhliadku_vykonal || '',
      kontakt_osoba: record.kontakt_osoba || '',
      kontakt_funkcia: record.kontakt_funkcia || '',
      data: (record.data && (record.data.matica || record.data.polozky)) ? record.data : { polozky: [] },
    },
    fields: editFields,
    onSubmit: async (values) => {
      if (!values.nazov || !values.nazov.trim()) throw new Error('Zadaj názov kalkulácie')
      const ps = (values.data && values.data.polozky) || []
      const dn = (dopyty.find(d => String(d.id) === String(values.dopyt_id)) || {}).nazov || ''
      const body = { nazov: values.nazov, typ: (ps[0] || {}).typ || 'omietka', dopyt_id: values.dopyt_id || '', poznamka: values.poznamka || '', etalon: record.etalon ? 1 : 0, data: { ...values.data, dopyt_nazov: dn } }
      for (const p of HLAVICKA_POLIA) body[p] = values[p]
      const r = await api(isNew ? '/api/kalkulacie' : '/api/kalkulacie/' + record.id, { method: isNew ? 'POST' : 'PUT', headers: pinHlavicka(), body: JSON.stringify(body) })
      const j = await r.json()
      if (!r.ok && j.pin_potrebny) { setRozpad(null); throw new Error('Rozpad ceny je zatvorený alebo schválenie vypršalo — otvor rozpad ceny PIN-om a ulož znova. Zmeny v okne ostali.') }
      if (!r.ok) throw new Error(j.error || 'Uloženie zlyhalo')
      savedRef.current = j
    },
    keepLockAfterSave: true,   // Kalkulácie = priebežné ukladanie — po Uložiť ostane editovateľné (Mirko 2026-07-01)
  })

  const k = ed.values
  const polozky = (k.data && k.data.polozky) || []
  const readOnly = !ed.canEdit

  const setData = (fn) => ed.set('data', { ...k.data, polozky: fn(polozky) })
  const addP = (typ) => setData(ps => [...ps, freshPolozka(typ)])
  const addMany = (items) => setData(ps => [...ps, ...items])
  const delP = (id) => setData(ps => ps.filter(p => p.id !== id))
  const patchP = (id, patch) => setData(ps => ps.map(p => p.id === id ? { ...p, ...patch } : p))
  const tot = polozky.reduce((a, p) => { const c = computeP(p); return { n: a.n + c.nakladSpolu, t: a.t + c.trzbaSpolu, z: a.z + c.ziskSpolu } }, { n: 0, t: 0, z: 0 })
  // Zoskupenie do sekcií podľa objektu — medzisúčty per objekt. Hlavičky len ak je objekt.
  const groups = []; const gmap = {}
  polozky.forEach(p => { const key = p.objekt || ''; if (!gmap[key]) { gmap[key] = { objekt: key, items: [] }; groups.push(gmap[key]) } gmap[key].items.push(p) })
  const showHeaders = groups.length > 1 || !!(groups[0] && groups[0].objekt)

  const validate = (v) => (!v.nazov || !v.nazov.trim()) ? 'Zadaj názov kalkulácie' : null
  const doSave = () => ed.goConfirm(validate)
  const doConfirm = async () => { const ok = await ed.submit(); if (ok) { ed.back(); onSaved(savedRef.current) } }  // ed.back() zatvorí confirm overlay (inak ostáva visieť pri editácii existujúcej)
  const doCancel = () => ed.requestClose(() => onSaved(savedRef.current))
  const archive = async () => { if (!record.id) { onCancel(); return } if (!window.confirm('Archivovať kalkuláciu „' + (k.nazov || '') + '"?')) return; try { await api('/api/kalkulacie/' + record.id, { method: 'DELETE' }); onArchived() } catch (_) {} }

  return (
    <div style={{ height: '100%', overflow: 'auto', padding: '2px 4px 16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0, fontSize: 17 }}>{isNew ? 'Nová kalkulácia' : (k.nazov || 'Kalkulácia')}</h3>
        {ed.isDirty && <span style={{ fontSize: 11, color: '#b45309', background: '#fef3c7', padding: '2px 8px', borderRadius: 6, fontWeight: 600 }}>neuložené zmeny</span>}
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
          {!isNew && <button onClick={archive} disabled={readOnly} style={{ ...btnGhost, opacity: readOnly ? 0.5 : 1 }} title="Archivovať">Archivovať</button>}
          <button onClick={doCancel} style={btnGhost}>Zavrieť</button>
          <button onClick={doSave} disabled={readOnly} style={{ ...btnBrand, opacity: readOnly ? 0.5 : 1, display: 'inline-flex', alignItems: 'center', gap: 6 }}><NavIcon name="check" size={15} />Uložiť →</button>
        </div>
      </div>

      {readOnly && ed.lockedBy && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#FDECEC', border: '1px solid #f0a8a8', borderRadius: 9, padding: '8px 12px', marginBottom: 10, fontSize: 12.5, color: '#dc2626' }}>
          <NavIcon name="lock" size={13} /> Kalkuláciu práve upravuje <strong>{ed.lockedBy}</strong> — editácia je zamknutá.
        </div>
      )}
      {ed.error && ed.phase === 'form' && (
        <div style={{ background: '#FDECEC', border: '1px solid #f0a8a8', borderRadius: 9, padding: '8px 12px', marginBottom: 10, fontSize: 12.5, color: '#dc2626' }}>{ed.error}</div>
      )}

      <div style={{ pointerEvents: readOnly ? 'none' : 'auto', opacity: readOnly ? 0.55 : 1 }}>
      {/* Súčet HORE — kompaktný horizontálny (Mirko 2026-06-27) */}
      <div style={{ display: 'flex', gap: 14, alignItems: 'center', flexWrap: 'wrap', background: '#faf9f6', border: '1px solid ' + BRAND + '33', borderRadius: 12, padding: '9px 16px', marginBottom: 10 }}>
        <span style={{ fontWeight: 800, fontSize: 13, color: '#1e293b' }}>Súčet za zákazku</span>
        <span style={{ display: 'flex', gap: 22, marginLeft: 'auto', flexWrap: 'wrap', alignItems: 'baseline' }}>
          <span><span style={{ fontSize: 11, color: '#94a3b8' }}>Náklad </span><b style={{ fontSize: 15 }}>{e0(tot.n)} €</b></span>
          <span><span style={{ fontSize: 11, color: '#94a3b8' }}>Tržba </span><b style={{ fontSize: 15, color: BRAND }}>{e0(tot.t)} €</b></span>
          <span><span style={{ fontSize: 11, color: '#94a3b8' }}>Zisk </span><b style={{ fontSize: 15, color: tot.z >= 0 ? '#15803d' : '#dc2626' }}>{e0(tot.z)} €</b></span>
        </span>
      </div>

      {/* HLAVIČKA — rovnaké polia ako na cenovej ponuke (Mirko 2026-09-20). Väzba na objednávateľa
          sa odtiaľto nesie ďalej: kalkulácia → ponuka → ZoD → zákazka. */}
      <div style={{ ...card, marginBottom: 10 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(190px,1fr))', gap: 10 }}>
          <div style={lab}>Zákazník *
            <div style={{ marginTop: 4 }}>
              <SearchableSelect value={String(k.customer_id || '')} onChange={v => {
                ed.set('customer_id', v)
                const c = zakaznici.find(x => String(x.id) === String(v))
                if (c) { if (!k.email) ed.set('email', c.email || ''); if (!k.telefon) ed.set('telefon', c.phone || c.contact || '') }
              }} options={zakaznici.map(c => ({ value: String(c.id), label: c.name + (c.id ? ' (' + c.id + ')' : '') }))}
                emptyLabel="— nevybraný —" placeholder="Hľadať zákazníka…" />
            </div>
          </div>
          <label style={lab}>Stavba / projekt<input value={k.stavba} onChange={e => ed.set('stavba', e.target.value)} style={fld} /></label>
          <label style={lab}>Číslo kalkulácie<input value={k.cislo} onChange={e => ed.set('cislo', e.target.value)} placeholder="doplní sa pri uložení" style={fld} /></label>
          <label style={lab}>Dátum<input type="date" value={k.datum} onChange={e => ed.set('datum', e.target.value)} style={fld} /></label>
          <label style={lab}>Platnosť (dní)<input value={k.platnost_dni} onChange={e => ed.set('platnost_dni', e.target.value)} inputMode="numeric" style={fld} /></label>
          <label style={lab}>Stav
            <select value={k.stav} onChange={e => ed.set('stav', e.target.value)} style={fld}>
              {STAVY.map(([v2, l2]) => <option key={v2} value={v2}>{l2}</option>)}
            </select>
          </label>
          <label style={lab}>Pripravil<input value={k.pripravil} onChange={e => ed.set('pripravil', e.target.value)} style={fld} /></label>
          <div style={lab}>Dopyt (voliteľné)
            <div style={{ marginTop: 4 }}>
              <SearchableSelect value={String(k.dopyt_id || '')} onChange={v => ed.set('dopyt_id', v)} options={dopyty.map(d => ({ value: String(d.id), label: d.nazov }))} emptyLabel="— bez dopytu —" placeholder="Hľadať dopyt…" />
            </div>
          </div>
          {/* ústava 131.10 + 0.J (p93): JEDEN blok kontaktnej osoby v celom Matrixe — osoba z registra partnera */}
          <KontaktnaOsoba customerId={k.customer_id} ulozFunkciu inp={fld}
            osoba={{ meno: k.kontakt_osoba, funkcia: k.kontakt_funkcia, telefon: k.telefon, email: k.email }}
            onZmena={o => { ed.set('kontakt_osoba', o.meno); ed.set('kontakt_funkcia', o.funkcia); ed.set('telefon', o.telefon); ed.set('email', o.email) }}
            placeholdery={{ telefon: 'prázdne = z karty partnera' }}
            obal={(tx, pole, kl) => <div key={kl} style={lab}>{tx}<div style={{ marginTop: 4 }}>{pole}</div></div>} />
          <label style={lab}>E-mail zákazníka 2<input value={k.email2} onChange={e => ed.set('email2', e.target.value)} style={fld} /></label>
          <label style={lab}>Obhliadku vykonal<input value={k.obhliadku_vykonal} onChange={e => ed.set('obhliadku_vykonal', e.target.value)} style={fld} /></label>
        </div>
        <label style={{ ...lab, display: 'block', marginTop: 10 }}>Názov *<input value={k.nazov} onChange={e => ed.set('nazov', e.target.value)} placeholder="napr. BD Ekobyt — omietky" style={fld} /></label>
        {k.stav === 'podana' && (
          <div style={{ marginTop: 10, background: '#FDF6E8', borderLeft: '4px solid #b4700f', borderRadius: 8, padding: '8px 12px', fontSize: 12.5 }}>
            Kalkulácia je <b>PODANÁ</b> — jej obsah sa už nemení, je to presne to, čo sme poslali. Meniť sa dá len stav.
          </div>
        )}
      </div>

      {/* VÝPOČET — priamo v obrazovke, pod hlavičkou (Mirko 2026-09-20) */}
      <div style={{ ...card, marginBottom: 10 }}>
        {!isNew && record && record.id && <NaseNaklady kalkId={record.id} cislo={k.cislo} nazov={k.nazov} />}
        <KalkulackaJC vnorene
          vstupZaznamu={(k.data && k.data.vstup) || null}
          vysledokZaznamu={(k.data && k.data.vypocet) || null}
          remeslaZaznamu={(k.data && k.data.remesla) || null}
          ulozeneO={ulozeneO}
          kalkulaciaId={isNew ? null : record.id}
          onVypocet={ulozVypocet}
          onZmenaVstupu={ulozVstup}
          onInsert={items => addMany(items)} />
      </div>

      {/* PRÍLOHY DOPYTU — výkaz výmer sa nenahráva znova, je už na dopyte (Mirko 2026-09-20: „a kde je VV?") */}
      {/* VÝKAZ VÝMER — ten istý komponent ako v Zákazkách (ústava 0.J), s prepínaním objektov
          a rekapituláciou. Nie surový Excel (Mirko 2026-09-20: „toto sa mi nepáči"). */}
      {!isNew && (
        <div style={{ ...card, marginBottom: 10 }}>
          <VVTab key={vvTick} kalkulaciaId={record.id} nadpis="Výkaz výmer"
            hlavicka={{ cislo: k.cislo, zakaznik: (zakaznici.find(c => String(c.id) === String(k.customer_id)) || {}).name || record.zakaznik_nazov || '',
              stavba: k.stavba, kontakt_osoba: record.reg_meno || k.kontakt_osoba, kontakt_funkcia: record.reg_funkcia || k.kontakt_funkcia, email: k.email, telefon: k.telefon || record.reg_telefon }} />
        </div>
      )}

      {isMatica(k.data) ? (
        rozpad ? (
          <div style={{ margin: '12px 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6, fontSize: 12, color: '#64748b', flexWrap: 'wrap' }}>
              <span>Rozpad ceny je otvorený do <b>{new Date(rozpad.do).toTimeString().slice(0, 5)}</b> — schválené PIN-om, potom sa sám zatvorí.</span>
              <span style={{ flex: 1 }} />
              <button type="button" onClick={() => setRozpad(null)} style={btnAdd}>Zavrieť rozpad ceny</button>
            </div>
            <KalkulacieMatica matica={k.data.matica} readOnly={readOnly}
              onChange={(m) => ed.set('data', { ...k.data, matica: m })} />
          </div>
        ) : (
          <div style={{ margin: '12px 0', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', border: '1px dashed #e2e8f0', borderRadius: 10, background: '#fafaf9', flexWrap: 'wrap' }}>
            <b style={{ fontSize: 13 }}>Rozpad ceny</b>
            <span style={{ fontSize: 12, color: '#64748b' }}>je zatvorený. Otvoriť a meniť ho možno len so schválením PIN-om (ústava 63).</span>
            <span style={{ flex: 1 }} />
            <button type="button" onClick={otvorRozpad} style={btnAdd}>Otvoriť rozpad ceny</button>
          </div>
        )
      ) : (<>
      <div style={{ display: 'flex', gap: 8, margin: '12px 0', flexWrap: 'wrap' }}>
        <button onClick={() => addP('omietka')} style={btnAdd}>+ Omietka</button>
        <button onClick={() => addP('malba')} style={btnAdd}>+ Maľba</button>
        <button onClick={() => addP('poter')} style={btnAdd}>+ Poter</button>
        <button onClick={() => setVvOpen(true)} style={{ ...btnAdd, marginLeft: 'auto', borderColor: BRAND, color: '#993c1d', display: 'inline-flex', alignItems: 'center', gap: 6 }}><NavIcon name="cp" size={15} />Importovať VV (AI)</button>
      </div>

      {!polozky.length && <div style={{ color: '#cbd5e1', padding: '20px', textAlign: 'center', border: '1px dashed #e2e8f0', borderRadius: 12 }}>Pridaj položku alebo importuj VV.</div>}
      {groups.map(g => {
        const gt = g.items.reduce((a, p) => { const c = computeP(p); return { n: a.n + c.nakladSpolu, t: a.t + c.trzbaSpolu, z: a.z + c.ziskSpolu } }, { n: 0, t: 0, z: 0 })
        return (
          <div key={g.objekt || '__none__'}>
            {showHeaders && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 12px', background: '#f4f3ee', border: '1px solid #eadfce', borderRadius: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                <span style={{ fontWeight: 800, color: '#92400e', fontSize: 13 }}>◆ {g.objekt || 'Bez objektu'}</span>
                <span style={{ fontSize: 11.5, color: '#94a3b8' }}>{g.items.length} {g.items.length === 1 ? 'položka' : 'položky'}</span>
                <span style={{ marginLeft: 'auto', fontSize: 12, color: '#64748b' }}>tržba <b style={{ color: BRAND }}>{e0(gt.t)} €</b> · zisk <b style={{ color: gt.z >= 0 ? '#15803d' : '#dc2626' }}>{e0(gt.z)} €</b></span>
              </div>
            )}
            {g.items.map(p => <PolozkaCard key={p.id} p={p} onPatch={patch => patchP(p.id, patch)} onDel={() => delP(p.id)} />)}
          </div>
        )
      })}

      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 8 }}>{polozky.length} {polozky.length === 1 ? 'položka' : 'položky'} · materiál +5 % rezerva</div>
      </>)}
      {k.dopyt_id && !isNew ? <PrilohyDopytu dopytId={k.dopyt_id} kalkulaciaId={record.id} onNacitane={() => setVvTick(x => x + 1)} /> : null}

      <label style={{ ...lab, display: 'block', marginTop: 10 }}>Poznámka<textarea value={k.poznamka} onChange={e => ed.set('poznamka', e.target.value)} rows={2} style={{ ...fld, marginTop: 4, resize: 'vertical' }} /></label>
      </div>{/* /body (read-only obal) */}

      {/* História zmien — audit kto/čo/kedy (ústava 12.0/1); len existujúci záznam */}
      {!isNew && (
        <div style={{ ...card, marginTop: 12 }}>
          <button onClick={() => setHistOpen(o => !o)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: 700, fontSize: 13, color: '#1e293b', display: 'inline-flex', alignItems: 'center', gap: 6, padding: 0 }}>{histOpen ? '▾' : '▸'} História zmien</button>
          {histOpen && <div style={{ marginTop: 8 }}><HistoryPanel module="kalkulacie" entityId={record.id} /></div>}
        </div>
      )}

      {vvOpen && <VvImportModal onClose={() => setVvOpen(false)} onAdd={items => { addMany(items); setVvOpen(false) }} />}
      {ed.phase === 'confirm' && <ConfirmSave isNew={isNew} nazov={k.nazov} diff={ed.diff} submitting={ed.submitting} error={ed.error} onBack={ed.back} onConfirm={doConfirm} />}
      {ed.dirtyProps.open && <DirtyDialog {...ed.dirtyProps} />}
    </div>
  )
}

// ── Confirm fáza (DIFF pred uložením, ústava 53.8) + Dirty dialóg (53.1) ──────
function ConfirmSave({ isNew, nazov, diff, submitting, error, onBack, onConfirm }) {
  return (
    <div onClick={onBack} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: 20, width: 'min(560px,95vw)', maxHeight: '85vh', overflowY: 'auto' }}>
        <h3 style={{ margin: '0 0 6px', fontSize: 16 }}>Skontroluj zmeny pred uložením</h3>
        {isNew ? (
          <p style={{ fontSize: 13, color: '#475569', margin: 0 }}>Vytvorí sa nová kalkulácia <strong>{nazov || '(bez názvu)'}</strong>.</p>
        ) : !diff.length ? (
          <p style={{ fontSize: 13, color: '#94a3b8', margin: 0 }}>Žiadne zmeny.</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5, marginTop: 4 }}>
            <thead><tr style={{ background: '#f6f5f1' }}><th style={cth}>Pole</th><th style={cth}>Pôvodné</th><th style={cth}>Nové</th></tr></thead>
            <tbody>
              {diff.map(d => (
                <tr key={d.name}>
                  <td style={ctd}>{d.label}</td>
                  <td style={{ ...ctd, color: '#94a3b8', textDecoration: 'line-through' }}>{d.from}</td>
                  <td style={{ ...ctd, color: '#15803d', fontWeight: 600 }}>{d.to}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {error && <div style={{ color: '#dc2626', fontSize: 12.5, marginTop: 8 }}>{error}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
          <button onClick={onBack} style={btnGhost}>← Späť na úpravu</button>
          <button onClick={onConfirm} disabled={submitting} style={{ ...btnBrand, opacity: submitting ? 0.6 : 1 }}>{submitting ? 'Ukladám…' : '✓ Potvrdiť uloženie'}</button>
        </div>
      </div>
    </div>
  )
}
function DirtyDialog({ open, onSave, onContinue, onDiscard }) {
  if (!open) return null
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300 }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 20, width: 'min(440px,94vw)' }}>
        <h3 style={{ margin: '0 0 6px', fontSize: 16 }}>Neuložené zmeny</h3>
        <p style={{ fontSize: 13, color: '#475569', margin: '0 0 16px' }}>Máš neuložené zmeny v kalkulácii. Čo s nimi?</p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <button onClick={onDiscard} style={{ ...btnGhost, color: '#dc2626', borderColor: '#f0a8a8' }}>Zahodiť</button>
          <button onClick={onContinue} style={btnGhost}>Pokračovať v úprave</button>
          <button onClick={onSave} style={btnBrand}>Uložiť</button>
        </div>
      </div>
    </div>
  )
}
const cth = { textAlign: 'left', padding: '6px 8px', borderBottom: '1px solid #e2e8f0', fontWeight: 600, color: '#64748b' }
const ctd = { padding: '6px 8px', borderBottom: '1px solid #f1f5f9' }

// ── Položka (rozbaliteľná karta s rozpočtom) ────────────────────────────────
function PolozkaCard({ p, onPatch, onDel }) {
  const [open, setOpen] = useState(false)  // zbalené default — klikni rozbalí kalkuláciu (Mirko 2026-06-27)
  const [pluFor, setPluFor] = useState(null)
  const t = TYPY[p.typ] || TYPY.omietka
  const c = computeP(p)
  const setSpecial = (key, val) => onPatch({ special: { ...p.special, [key]: val } })
  const setLine = (i, val) => onPatch({ lines: p.lines.map((l, j) => j === i ? { ...l, v: val } : l) })
  const setLineField = (i, patch) => onPatch({ lines: p.lines.map((l, j) => j === i ? { ...l, ...patch } : l) })
  const setLinePlu = (i, r) => setLineField(i, { l: r.name || p.lines[i].l, plu: r.plu, pluName: r.name, pluPrice: Number(r.last_price) || 0, pluUnit: r.unit, cena: Number(r.last_price) || 0, cenaUnit: r.unit })
  const setLineUnlink = (i) => setLineField(i, { plu: null, pluName: null, pluPrice: null, pluUnit: null })
  const tagStyle = (tag) => tag === 'PLU' ? { bg: '#FAECE7', c: '#993C1D' } : tag === 'odhad' ? { bg: '#FAEEDA', c: '#854F0B' } : { bg: '#E1F5EE', c: '#0F6E56' }

  return (
    <div style={{ ...card, padding: 0, overflow: 'hidden' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto auto auto auto', gap: 10, alignItems: 'center', padding: '10px 12px', background: '#fbfaf8' }}>
        <button onClick={() => setOpen(o => !o)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: BRAND, fontSize: 13 }}>{open ? '▾' : '▸'}</button>
        <div>
          <input value={p.popis} onChange={e => onPatch({ popis: e.target.value })} style={{ ...fld, fontWeight: 600, padding: '5px 8px' }} />
          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
            <select value={p.typ} onChange={e => onPatch({ ...freshPolozka(e.target.value, { objekt: p.objekt, popis: p.popis, kod: p.kod, mnozstvo: p.mnozstvo }), id: p.id })} style={{ fontSize: 11, border: '1px solid #e2e8f0', borderRadius: 5, padding: '1px 4px', fontFamily: 'inherit' }}>
              {Object.keys(TYPY).map(tk => <option key={tk} value={tk}>{TYPY[tk].l}</option>)}
            </select>
            {p.objekt ? <span style={{ marginLeft: 6, color: '#92400e', fontWeight: 600 }}>◆ {p.objekt}</span> : null}
            {p.kod ? <span style={{ marginLeft: 6, fontFamily: 'monospace' }}>{p.kod}</span> : null}
          </div>
        </div>
        <label style={{ fontSize: 11, color: '#64748b', textAlign: 'right' }}>Množstvo m²<input type="number" step="any" value={p.mnozstvo} onChange={e => onPatch({ mnozstvo: e.target.value })} placeholder="z VV" style={{ ...fld, width: 90, textAlign: 'right', marginTop: 2 }} /></label>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 10.5, color: '#94a3b8' }}>Náklad/m²</div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>{e2(c.naklad)} €</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 10.5, color: '#94a3b8' }}>Cena/m²</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: BRAND }}>{e2(c.predajna)} €</div>
        </div>
        <button onClick={onDel} title="Odstrániť" style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#cbd5e1', fontSize: 14 }}>✕</button>
      </div>

      {open && (
        <div style={{ padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 6 }}>
          {(t.special || []).length > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 7, padding: '8px 10px', background: '#f8fafc', borderRadius: 8, marginBottom: 4 }}>
              {t.special.map(s => (
                <label key={s.k} style={{ fontSize: 12, color: '#475569', display: 'flex', alignItems: 'center', gap: 6 }}>
                  {s.l}{s.tag && <span style={{ fontSize: 10, background: tagStyle(s.tag).bg, color: tagStyle(s.tag).c, padding: '1px 5px', borderRadius: 5 }}>{s.tag}{s.tag === 'PLU' ? ' +5%' : ''}</span>}
                  {s.tag === 'PLU' && <button type="button" onClick={() => setPluFor({ special: s.k })} title="Vybrať z PLU (MKsoft)" style={{ marginLeft: 'auto', border: '1px solid ' + BRAND, background: '#fff', color: '#993c1d', borderRadius: 6, cursor: 'pointer', fontSize: 11, padding: '3px 7px', fontFamily: 'inherit' }}>PLU</button>}
                  <input type="number" step="any" value={p.special[s.k]} onChange={e => setSpecial(s.k, e.target.value)} style={{ ...fld, width: 74, textAlign: 'right', marginLeft: s.tag === 'PLU' ? 6 : 'auto' }} />
                  <span style={{ width: 34, fontSize: 11, color: '#94a3b8' }}>{s.u}</span>
                </label>
              ))}
            </div>
          )}
          {t.mat && (
            <div style={{ display: 'flex', alignItems: 'center', fontSize: 12.5, color: '#475569', padding: '2px 0' }}>
              <span style={{ flex: 1 }}>{t.matLabel} <span style={{ fontSize: 10, background: '#F1EFE8', color: '#5F5E5A', padding: '1px 5px', borderRadius: 5 }}>počíta sa</span></span>
              <span style={{ fontWeight: 600 }}>{e2(c.matPerM2)} €</span>
            </div>
          )}
          {/* hlavička + riadky = tabuľka s vodorovným posunom, stĺpec poznámka vždy vpravo (Mirko 2026-06-29) */}
          <div style={{ overflowX: 'auto', paddingBottom: 4 }}>
          <div style={{ minWidth: 'max-content', display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 10, color: '#94a3b8' }}>
            <span style={{ width: 22, flexShrink: 0 }}></span><span style={{ width: 34, flexShrink: 0 }}></span><span style={{ width: 140, flexShrink: 0 }}>Položka</span>
            <span style={{ width: 220, flexShrink: 0, fontWeight: 600 }}>poznámka — ako rátam spotrebu</span>
            <span style={{ width: 46, flexShrink: 0 }}></span>
            <span style={{ display: 'inline-flex', gap: 7, alignItems: 'center', background: PREP_BG, borderRadius: 6, padding: '2px 8px', flexShrink: 0, boxSizing: 'border-box' }}>
              <span style={{ width: 72, textAlign: 'right' }}>cena</span><span style={{ width: 32 }}>€/MJ</span><span style={{ width: 58, textAlign: 'right' }}>počet</span><span style={{ width: 12 }}></span><span style={{ width: 58, textAlign: 'right' }}>vým./ks</span><span style={{ width: 8 }}></span><span style={{ width: 58, textAlign: 'right' }}>plocha</span><span style={{ width: 18 }}></span>
            </span>
            <span style={{ width: 62, textAlign: 'right', flexShrink: 0 }}>€/m²</span>
          </div>
          {p.lines.map((l, i) => (
            <div key={l.k} style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12.5, color: '#475569', borderBottom: '1px solid #f5f5f4', paddingBottom: 5, flexWrap: 'nowrap' }}>
              <button type="button" onClick={() => onPatch({ lines: p.lines.filter((_, j) => j !== i) })} title="Odobrať položku" style={{ border: '1px solid #e2e8f0', background: '#fff', color: '#dc2626', borderRadius: 6, width: 22, height: 22, cursor: 'pointer', fontSize: 15, lineHeight: 1, flexShrink: 0, fontFamily: 'inherit', padding: 0 }}>−</button>
              <button type="button" onClick={() => setPluFor({ line: i })} title={l.plu ? ('PLU: ' + l.pluName) : 'Cena z PLU (živá MKsoft)'} style={{ border: '1px solid ' + BRAND, background: l.plu ? '#FAECE7' : '#fff', color: '#993c1d', borderRadius: 6, cursor: 'pointer', fontSize: 11, padding: '3px 6px', fontFamily: 'inherit', flexShrink: 0, width: 34 }}>PLU</button>
              <input value={l.l} onChange={e => setLineField(i, { l: e.target.value })} placeholder="názov položky" style={{ ...fld, width: 140, flexGrow: 0, flexShrink: 0, padding: '5px 8px' }} />
              <input value={l.note || ''} onChange={e => setLineField(i, { note: e.target.value })} placeholder="poznámka — ako rátam spotrebu (napr. 1 vrece 25 kg / 60 m²)" title="Poznámka: ako počítam spotrebu — pre teba aj ostatných" style={{ width: 220, flexShrink: 0, padding: '5px 8px', border: '1px solid #eef0f3', borderRadius: 6, fontSize: 11.5, fontFamily: 'inherit', color: '#475569', background: '#fffdf7', outline: 'none' }} />
              <span style={{ width: 46, flexShrink: 0, display: 'inline-flex', justifyContent: 'flex-start' }}>{l.tag && l.tag !== 'PLU' && <span style={{ fontSize: 10, background: tagStyle(l.tag).bg, color: tagStyle(l.tag).c, padding: '1px 5px', borderRadius: 5 }}>{l.tag}</span>}</span>
              <span style={{ display: 'inline-flex', gap: 7, alignItems: 'center', background: PREP_BG, borderRadius: 6, padding: '2px 8px', flexShrink: 0, boxSizing: 'border-box' }}>
                <input type="number" step="any" value={l.cena} onChange={e => setLineField(i, { cena: e.target.value })} title="cena za jednotku" style={{ ...fld, width: 72, textAlign: 'right', padding: '5px 6px' }} />
                <span style={{ width: 32, fontSize: 10.5, color: '#64748b' }}>€/{l.cenaUnit || 'ks'}</span>
                <input type="number" step="any" value={l.pocet} onChange={e => setLineField(i, { pocet: e.target.value })} title="počet (napr. 50 ks alebo 1 balenie)" style={{ ...fld, width: 58, textAlign: 'right', padding: '5px 6px' }} />
                <span style={{ width: 12, textAlign: 'center', fontSize: 11, color: '#64748b' }}>×</span>
                <input type="number" step="any" value={l.vymeraKs} onChange={e => setLineField(i, { vymeraKs: e.target.value })} title="výmera/ks (napr. 2,75 bm/ks; 1 ak netreba)" style={{ ...fld, width: 58, textAlign: 'right', padding: '5px 6px' }} />
                <span style={{ width: 8, textAlign: 'center', fontSize: 11, color: '#64748b' }}>/</span>
                <input type="number" step="any" value={l.plocha} onChange={e => setLineField(i, { plocha: e.target.value })} title="na koľko m²" style={{ ...fld, width: 58, textAlign: 'right', padding: '5px 6px' }} />
                <span style={{ width: 18, fontSize: 11, color: '#64748b' }}>m²</span>
              </span>
              <span style={{ width: 62, textAlign: 'right', fontWeight: 700, color: '#1e293b', flexShrink: 0 }}>{e2(lineVal(l))} €</span>
            </div>
          ))}
          </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginTop: 4, paddingTop: 7, borderTop: '2px solid #e2e8f0', flexWrap: 'wrap' }}>
            <span style={{ width: 22, flexShrink: 0 }}></span>
            <span style={{ width: 34, flexShrink: 0 }}></span>
            <div style={{ width: 140, flexShrink: 0 }}><button type="button" onClick={() => onPatch({ lines: [...p.lines, { k: uid(), l: 'Nová položka', cena: 0, cenaUnit: 'm²', pocet: 1, vymeraKs: 1, plocha: 1 }] })} style={{ border: '1px dashed #cbd5e1', background: '#fff', color: '#64748b', borderRadius: 7, padding: '5px 11px', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}>+ Pridať položku</button></div>
            <span style={{ width: 46, flexShrink: 0 }}></span>
            <span style={{ width: 297, textAlign: 'right', fontWeight: 800, fontSize: 13, color: '#1e293b', flexShrink: 0 }}>Total náklady / m²</span>
            <span style={{ width: 58, textAlign: 'right', fontWeight: 800, fontSize: 16, color: '#1e293b', flexShrink: 0 }}>{e2(c.naklad)} €</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginTop: 6, flexWrap: 'wrap' }}>
            <span style={{ width: 22, flexShrink: 0 }}></span>
            <span style={{ width: 34, flexShrink: 0 }}></span>
            <span style={{ width: 140, flexShrink: 0 }}></span>
            <span style={{ width: 46, flexShrink: 0 }}></span>
            <span style={{ width: 297, textAlign: 'right', fontWeight: 700, fontSize: 13, color: '#1e293b', flexShrink: 0 }}>Predajná cena €/m²</span>
            <input type="number" step="0.01" value={p.predajna} onChange={e => onPatch({ predajna: e.target.value })} style={{ ...fld, width: 96, textAlign: 'right', fontWeight: 700, padding: '5px 8px', flexShrink: 0 }} />
          </div>
          <div style={{ display: 'flex', gap: 14, marginTop: 6, paddingTop: 8, borderTop: '1px solid #eef0f3' }}>
            <Tg label="Zisk/m²" val={e2(c.zisk) + ' €'} c={c.zisk >= 0 ? '#15803d' : '#dc2626'} />
            <Tg label="Rabat" val={e0(c.rabat) + ' %'} />
            {c.mn > 0 && <Tg label="Tržba položky" val={e0(c.trzbaSpolu) + ' €'} c={BRAND} />}
            {c.mn > 0 && <Tg label="Zisk položky" val={e0(c.ziskSpolu) + ' €'} c={c.ziskSpolu >= 0 ? '#15803d' : '#dc2626'} />}
          </div>
        </div>
      )}
      {pluFor && <PluPicker onClose={() => setPluFor(null)} onPick={r => { if (pluFor.line != null) setLinePlu(pluFor.line, r); else if (pluFor.special) setSpecial(pluFor.special, r.last_price); setPluFor(null) }} />}
    </div>
  )
}

// ── VV import (AI) ──────────────────────────────────────────────────────────
function VvImportModal({ onClose, onAdd }) {
  const [text, setText] = useState('')
  const [busy, setBusy] = useState(false)
  const [items, setItems] = useState(null)
  const [q, setQ] = useState('')
  const [onlyRel, setOnlyRel] = useState(false)
  const parse = async (file) => {
    setBusy(true)
    try {
      const fd = new FormData()
      if (file) fd.append('file', file); else fd.append('text', text)
      const r = await fetch('/api/budget-items/ai-parse', { method: 'POST', headers: { Authorization: 'Bearer ' + tok() }, body: fd })
      const j = await r.json()
      if (!r.ok) throw new Error(j.error || 'AI parse zlyhal')
      const arr = (j.items || []).map(it => ({ objekt: it.objekt || '', popis: it.popis || '', kod: it.kod || '', mj: it.mj || 'm2', mnozstvo: it.mnozstvo || 0, typ: guessTyp(it.kod), sel: /^(61|63|78[34])/.test(String(it.kod || '')) }))
      setItems(arr)
    } catch (e) { alert('Chyba: ' + e.message) } finally { setBusy(false) }
  }
  const add = () => { const chosen = (items || []).filter(i => i.sel).map(i => freshPolozka(i.typ, { objekt: i.objekt, popis: i.popis, kod: i.kod, mnozstvo: i.mnozstvo })); if (!chosen.length) { alert('Vyber aspoň jednu položku'); return } onAdd(chosen) }
  const match = (it) => (!q.trim() || hladaj((it.popis + ' ' + it.kod + ' ' + it.objekt), q.trim().toLowerCase())) && (!onlyRel || /^(61|63|78[34])/.test(String(it.kod || '')))
  const toggleVisible = (val) => setItems(s => s.map(x => match(x) ? { ...x, sel: val } : x))
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: 20, width: 'min(680px,95vw)', maxHeight: '90vh', overflowY: 'auto' }}>
        <h3 style={{ margin: '0 0 4px', fontSize: 17, display: 'inline-flex', alignItems: 'center', gap: 8 }}><NavIcon name="cp" size={18} />Import výkazu výmer (AI)</h3>
        <div style={{ fontSize: 12.5, color: '#94a3b8', marginBottom: 12 }}>Vlož text z VV (kopíruj z Excelu), alebo nahraj Excel/PDF/foto. AI vytiahne položky — ty vyberieš ktoré. Množstvo sa doplní automaticky.</div>
        {!items && (
          <>
            <textarea value={text} onChange={e => setText(e.target.value)} rows={6} placeholder="Sem vlož riadky z výkazu výmer (popis, kód, MJ, množstvo)…" style={{ ...fld, resize: 'vertical', fontFamily: 'monospace', fontSize: 12 }} />
            <div style={{ display: 'flex', gap: 8, marginTop: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              <button onClick={() => parse(null)} disabled={busy || !text.trim()} style={{ ...btnBrand, opacity: (busy || !text.trim()) ? 0.5 : 1 }}>{busy ? 'Spracúvam…' : 'Spracovať text (AI)'}</button>
              <span style={{ color: '#cbd5e1' }}>alebo</span>
              <label style={{ ...btnGhost, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}><NavIcon name="doks" size={15} />Excel / PDF / foto<input type="file" accept=".xlsx,.xls,.csv,.pdf,image/*" onChange={e => { if (e.target.files[0]) parse(e.target.files[0]) }} style={{ display: 'none' }} /></label>
              <button onClick={onClose} style={{ ...btnGhost, marginLeft: 'auto' }}>Zrušiť</button>
            </div>
          </>
        )}
        {items && (
          <>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8, flexWrap: 'wrap' }}>
              <input value={q} onChange={e => setQ(e.target.value)} placeholder="Hľadať (popis, kód, objekt)…" style={{ ...fld, flex: 1, minWidth: 200 }} />
              <label style={{ fontSize: 12, color: '#475569', display: 'inline-flex', alignItems: 'center', gap: 5, whiteSpace: 'nowrap', cursor: 'pointer' }}><input type="checkbox" checked={onlyRel} onChange={e => setOnlyRel(e.target.checked)} />len omietky/maľby/potery</label>
            </div>
            <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 6 }}>
              {items.filter(match).length} zobrazených z {items.length} · {items.filter(i => i.sel).length} vybraných
              <button type="button" onClick={() => toggleVisible(true)} style={linkBtn}>označiť zobrazené</button>
              <button type="button" onClick={() => toggleVisible(false)} style={linkBtn}>odznačiť</button>
            </div>
            <div style={{ maxHeight: '44vh', overflowY: 'auto', border: '1px solid #eef0f3', borderRadius: 8 }}>
              {(() => {
                const vis = items.map((it, i) => ({ it, i })).filter(({ it }) => match(it))
                if (!vis.length) return <div style={{ padding: 14, color: '#cbd5e1', fontSize: 12 }}>Nič nezodpovedá filtru.</div>
                return vis.map(({ it, i }, vi) => {
                  const showHeader = vi === 0 || vis[vi - 1].it.objekt !== it.objekt
                  return (
                    <React.Fragment key={i}>
                      {showHeader && <div style={{ padding: '5px 10px', background: '#f4f3ee', fontSize: 11, fontWeight: 700, color: '#92400e', borderBottom: '1px solid #eadfce', position: 'sticky', top: 0 }}>{it.objekt ? '◆ ' + it.objekt : '◆ Bez objektu'}</div>}
                      <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto auto', gap: 8, alignItems: 'center', padding: '7px 10px', borderBottom: '1px solid #f5f5f4', background: it.sel ? '#fbfaf8' : '#fff' }}>
                        <input type="checkbox" checked={it.sel} onChange={e => setItems(s => s.map((x, j) => j === i ? { ...x, sel: e.target.checked } : x))} />
                        <div><div style={{ fontSize: 12.5, color: '#1e293b' }}>{it.popis}</div><div style={{ fontSize: 10.5, color: '#94a3b8', fontFamily: 'monospace' }}>{it.kod || '—'} · {it.mnozstvo} {it.mj}</div></div>
                        <select value={it.typ} onChange={e => setItems(s => s.map((x, j) => j === i ? { ...x, typ: e.target.value } : x))} style={{ fontSize: 11, border: '1px solid #e2e8f0', borderRadius: 5, padding: '2px 4px', fontFamily: 'inherit' }}>
                          {Object.keys(TYPY).map(tk => <option key={tk} value={tk}>{TYPY[tk].l}</option>)}
                        </select>
                        <span style={{ fontSize: 12, fontWeight: 600, textAlign: 'right', width: 64 }}>{it.mnozstvo} m²</span>
                      </div>
                    </React.Fragment>
                  )
                })
              })()}
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setItems(null)} style={btnGhost}>← Späť</button>
              <button onClick={add} style={btnBrand}>+ Pridať vybrané ({items.filter(i => i.sel).length})</button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

// ── PLU picker (MKsoft ceny) ───────────────────────────────────────────────
function PluPicker({ onPick, onClose }) {
  const [q, setQ] = useState('')
  const [rows, setRows] = useState([])
  const [busy, setBusy] = useState(false)
  useEffect(() => {
    if (!q.trim()) { setRows([]); return }
    let alive = true; setBusy(true)
    const t = setTimeout(() => {
      api('/api/kalkulacie/plu/search?q=' + encodeURIComponent(q)).then(r => r.json()).then(d => { if (alive) setRows(Array.isArray(d) ? d : []) }).catch(() => {}).finally(() => { if (alive) setBusy(false) })
    }, 250)
    return () => { alive = false; clearTimeout(t) }
  }, [q])
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: 18, width: 'min(560px,94vw)', maxHeight: '80vh', overflowY: 'auto' }}>
        <h3 style={{ margin: '0 0 4px', fontSize: 16 }}>PLU z MKsoft</h3>
        <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 10 }}>Vyber materiál — doplní sa aktuálna cena (výpočet pridá +5 % rezervu).</div>
        <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="hľadaj (mixfloor, cement, baumit, piesok…)" style={fld} />
        <div style={{ marginTop: 10, border: '1px solid #eef0f3', borderRadius: 8 }}>
          {busy && <div style={{ padding: 12, color: '#94a3b8', fontSize: 12 }}>Hľadám…</div>}
          {!busy && !rows.length && q.trim() && <div style={{ padding: 12, color: '#cbd5e1', fontSize: 12 }}>Nič nenájdené.</div>}
          {rows.map(r => (
            <div key={r.plu} onClick={() => onPick(r)} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', borderBottom: '1px solid #f5f5f4', cursor: 'pointer' }}>
              <div style={{ flex: 1 }}><div style={{ fontSize: 12.5, color: '#1e293b' }}>{r.name}</div><div style={{ fontSize: 10.5, color: '#94a3b8', fontFamily: 'monospace' }}>PLU {r.plu} · {r.unit}</div></div>
              <div style={{ fontSize: 13, fontWeight: 700 }}>{e2(r.last_price)} €<span style={{ fontSize: 10, color: '#94a3b8' }}>/{r.unit}</span></div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: 'right', marginTop: 10 }}><button onClick={onClose} style={btnGhost}>Zavrieť</button></div>
      </div>
    </div>
  )
}

// ── atoms ───────────────────────────────────────────────────────────────────
const Tg = ({ label, val, c }) => (<div><div style={{ fontSize: 10, color: '#94a3b8' }}>{label}</div><div style={{ fontSize: 12.5, fontWeight: 700, color: c || '#1e293b' }}>{val}</div></div>)
const Row = ({ l, v, c, bold }) => (<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '3px 0', fontSize: bold ? 14 : 13 }}><span style={{ color: '#64748b' }}>{l}</span><span style={{ fontWeight: bold ? 800 : 600, color: c || '#1e293b' }}>{v}</span></div>)
const btnBrand = { padding: '9px 16px', border: 'none', background: BRAND, color: '#fff', borderRadius: 9, cursor: 'pointer', fontWeight: 700, fontFamily: 'inherit' }
const btnGhost = { padding: '8px 14px', border: '1px solid #d6dde6', background: '#fff', borderRadius: 9, cursor: 'pointer', fontWeight: 600, fontFamily: 'inherit' }
const btnAdd = { padding: '7px 13px', border: '1px solid #d6dde6', background: '#fff', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontFamily: 'inherit', fontSize: 13 }
const linkBtn = { marginLeft: 8, border: 'none', background: 'transparent', color: '#993c1d', cursor: 'pointer', fontSize: 11.5, fontFamily: 'inherit', textDecoration: 'underline' }
const fld = { width: '100%', padding: '8px 10px', border: '1px solid #d6dde6', borderRadius: 8, fontFamily: 'inherit', fontSize: 13, boxSizing: 'border-box', outline: 'none' }
const lab = { fontSize: 12, color: '#475569', display: 'flex', flexDirection: 'column' }
const card = { background: '#fff', border: '1px solid #eef0f3', borderRadius: 12, padding: 14, marginBottom: 12 }
const cardTitle = { fontWeight: 700, fontSize: 13, color: '#1e293b', marginBottom: 10 }
